import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Link as MuiLink } from "@material-ui/core";

const Container = styled.nav`
  width: 100%;
  padding: 24px 0;
  margin-bottom: 32px;
  background: linear-gradient(135deg, rgba(37, 99, 235, 0.03) 0%, rgba(59, 130, 246, 0.02) 100%);
  border-left: 3px solid var(--primary);
  border-radius: 8px;

  ol.MuiBreadcrumbs-ol {
    padding: 0 24px;
  }

  .MuiBreadcrumbs-separator {
    color: var(--primary-light);
    margin: 0 12px;
    font-size: 1rem;
    font-weight: 600;
  }

  a.MuiLink-root {
    color: var(--primary);
    text-decoration: underline;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 500;
    transition: all 0.2s ease;
    line-height: 1.5;
    position: relative;

    &:hover {
      color: var(--primary-light);
      text-decoration: underline;
    }
  }

  .MuiTypography-root {
    color: var(--neutral);
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.5;
  }

  @media (max-width: 768px) {
    padding: 20px 0;
    margin-bottom: 24px;
    border-left-width: 2px;

    ol.MuiBreadcrumbs-ol {
      padding: 0 20px;
    }

    .MuiBreadcrumbs-separator {
      margin: 0 8px;
      font-size: 1rem;
    }

    a.MuiLink-root,
    .MuiTypography-root {
      font-size: 1rem;
    }
  }
`;

interface BreadCrumsContainerProps {
  children: React.ReactNode;
}

export const BreadCrumsContainer: React.FC<BreadCrumsContainerProps> = ({ children }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isOnlyContent = searchParams.has('onlyContent');

  // Não renderizar breadcrumb em modo onlyContent
  if (isOnlyContent) {
    return null;
  }

  return <Container aria-label="breadcrumb">{children}</Container>;
};

interface BreadcrumbLinkProps {
  href: string;
  color?: "inherit" | "initial" | "primary" | "secondary" | "textPrimary" | "textSecondary" | "error";
  children: React.ReactNode;
}

export const BreadcrumbLink: React.FC<BreadcrumbLinkProps> = ({ href, color = "inherit", children }) => {
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    navigate(href);
  };

  return (
    <MuiLink color={color} href={href} onClick={handleClick}>
      {children}
    </MuiLink>
  );
};

export { Breadcrumb } from "./breadcrumb.component";